import {Button, Modal} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import 'react-medium-image-zoom/dist/styles.css'
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import {FilePond, registerPlugin} from "react-filepond";
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import NsModalHeader from "../../../../components/modal/NsModalHeader";
import Translate from "../../../../components/Translate";
import AutocompleteTextNoFormik from "../../../../components/AutocompleteTextNoFormik";
import {aggiornaTitoloApi, aggiungiTitoloApi, getTitoloByIdApi} from "../../../../services/ArchivioServices";
import {LoaderContext} from "../../../../context/LoaderContext";
import {getModelliApi} from "../../../../services/VeicoliServices";

// Registrazione plugins
registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileValidateType
);


export default function ModalAddModelloArchivio({
                                                   idMarca,
                                                   marca,
                                                   idTitolo,
                                                   show,
                                                   handleClose,
                                                   submitOk
                                               }) {


    const [modelli, setModelli] = useState([]);
    const [files, setFiles] = useState([]);
    const [modello, setModello] = useState('');
    const [annoDa, setAnnoDa] = useState('');
    const [annoA, setAnnoA] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    // Reset completo allo stato iniziale
    const resetState = () => {
        setFiles([]);
        setModello('');
        setAnnoDa('');
        setAnnoA('');
        setIsSaving(false);
    };

    // Funzione per gestire il salvataggio manuale
    const handleSave = async () => {
        if (!modello) {
            alert("Il Modello è obbligatorio.");
            return;
        }

        // Mostra feedback di caricamento
        setIsSaving(true);

        const formData = new FormData();
        formData.append('id_archivio_marca', idMarca);
        formData.append('modello', modello.trim());
        formData.append('anno_da', annoDa);
        formData.append('anno_a', annoA);
        formData.append('tipo_veicolo', marca.tipo_veicolo);

        files.forEach(fileItem => {
            formData.append('files', fileItem.file);
        });

        try {
            var response;

            if (idTitolo) {
                // Modifica titolo
                response = await aggiornaTitoloApi(idTitolo, formData);
            } else {
                // Aggiungi titolo
                response = await aggiungiTitoloApi(formData);
            }

            submitOk(response.data);
            handleClose();
        } catch (error) {
            console.error("Upload failed:", error.response ? error.response.data : error.message);
            // Mostra un messaggio di errore all'utente
            alert("Errore durante il caricamento del file. Riprova.");
        } finally {
            setIsSaving(false);
        }
    };

    async function getModelli(modelli) {
        const response = await getModelliApi({
            modello: modelli
        });
        setModelli(response.data.data);
    }

    async function getTitolo() {
        startChiamata();
        const response = await getTitoloByIdApi(idTitolo);
        endChiamata();

        let dati = response.data.data;
        if (dati) {
            setModello(dati.modello);
            setAnnoDa(dati.anno_da);
            setAnnoA(dati.anno_a);
        }
    }

    useEffect(() => {
        resetState();
        if (idTitolo && idTitolo !== '') {
            getTitolo();
        }
    }, [idTitolo, idMarca]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size={"xl"}
        >
            <NsModalHeader title={(idTitolo && idTitolo !== '') ? `Modifica titolo ${marca && marca.marca} ${modello}` : 'Aggiungi nuovo titolo'}/>
            <Modal.Body>
                <div className={"row g-3"}>
                    <div className={"col-md-6"}>
                        <label htmlFor="marca" className="form-label">Modello*:</label>
                        <AutocompleteTextNoFormik
                            name={"modello"}
                            value={modello}
                            filterFunction={getModelli}
                            filteredValues={modelli}
                            handlerChange={setModello}
                            handlerSelect={setModello}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="anno_da" className="form-label">Anno inizio produzione:</label>
                        <input
                            type={"number"}
                            id={"anno_da"}
                            name={"anno_da"}
                            className={"form-control"}
                            value={annoDa}
                            onChange={(ev) => setAnnoDa(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-6"}>
                        <label htmlFor="anno_a" className="form-label">Anno fine produzione:</label>
                        <input
                            type={"number"}
                            id={"anno_a"}
                            name={"anno_a"}
                            className={"form-control"}
                            value={annoA}
                            onChange={(ev) => setAnnoA(ev.target.value)}
                        />
                    </div>
                    <div className={"col-md-12 mt-4"}>
                        <label className="form-label">Documento/i:</label>
                        <FilePond
                            files={files}
                            onupdatefiles={setFiles}
                            acceptedFileTypes={[
                                "image/png", "image/jpeg", "image/gif", "image/bmp", "image/svg+xml", "image/heic"
                            ]}
                            allowFileTypeValidation={true}
                            fileValidateTypeDetectType={(source, type) =>
                                new Promise((resolve) => {
                                    resolve(type);
                                })
                            }
                            allowMultiple={true}
                            allowRevert={true}
                            allowReorder={true}
                            allowImagePreview={true}
                            imagePreviewMaxHeight={200}
                            name="files"
                            labelIdle={
                                'Trascina qui i tuoi documenti o <span class="filepond--label-action">Cerca</span>'
                            }
                            labelInvalidField={'Il campo contiene file non validi'}
                            labelFileWaitingForSize={'In attesa della dimensione'}
                            labelFileSizeNotAvailable={'Dimensione non disponibile'}
                            labelFileLoading={'Caricamento'}
                            labelFileLoadError={'Errore durante il caricamento'}
                            labelFileProcessing={'Caricamento'}
                            labelFileProcessingComplete={'Caricamento completato'}
                            labelFileProcessingAborted={'Caricamento annullato'}
                            labelFileProcessingError={'Errore durante il caricamento'}
                            labelTapToCancel={'tocca per annullare'}
                            labelTapToRetry={'tocca per riprovare'}
                            labelTapToUndo={'tocca per annullare'}
                            labelButtonRemoveItem={'Rimuovi'}
                            labelButtonAbortItemLoad={'Annulla'}
                            labelButtonRetryItemLoad={'Riprova'}
                            labelButtonAbortItemProcessing={'Annulla'}
                            labelButtonUndoItemProcessing={'Annulla'}
                            labelButtonRetryItemProcessing={'Riprova'}
                            labelButtonProcessItem={'Carica'}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={isSaving}>
                    <Translate>Chiudi</Translate>
                </Button>
                <Button variant="primary" onClick={handleSave} disabled={!idTitolo && (isSaving || !modello)}>
                    {isSaving ? 'Salvataggio...' : <Translate>Salva</Translate>}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}